module.exports = __webpack_public_path__ + "img/EMSV2.95d38e91.png";